export const invoiceProfiles = {
  productAndPrice: 'productAndPrice',
  productAndPriceAndFlight: 'productAndPriceAndFlight',
  productAndPriceAndFlightAndDay: 'productAndPriceAndFlightAndDay',
}
